import {
  Button,
  TextControl,
  TextareaControl,
  SelectControl,
  Placeholder,
  PanelBody,
  PanelRow,
  TextHighlight,
  ToggleControl,
  CheckboxControl,
} from '@wordpress/components';
import {
  MediaUpload,
  MediaUploadCheck,
  useBlockProps,
  InspectorControls,
} from '@wordpress/block-editor';
import { select, useSelect } from '@wordpress/data';
import { useEffect, RawHTML } from '@wordpress/element';

export default function Edit({ attributes, setAttributes }) {
  const { slides, padding, title, positiontitle, url, colorbg, container } =
    attributes;
  const { pages } = useSelect(() => {
    return {
      pages: select('core').getEntityRecords('postType', 'page', {
        page_group: 122,
        per_page: -1,
      }),
    };
  });

  // Обновление атрибута
  const handleChange = (taxonomyName, termId, isChecked) => {
    const selectedValues = attributes[taxonomyName] || [];
    const newValues = isChecked
      ? [...selectedValues, termId]
      : selectedValues.filter((id) => id !== termId);
    console.log(newValues);
    setAttributes({ [taxonomyName]: newValues });
  };

  const blockProps = useBlockProps({
    className: 'custom-slider',
  });

  return (
    <>
      <InspectorControls>
        <PanelBody title="Настройки блока" initialOpen={true}>
          <TextControl
            __next40pxDefaultSize
            __nextHasNoMarginBottom={true}
            label="Заголовок блока"
            value={title}
            onChange={(value) => setAttributes({ title: value })}
            placeholder="Введите текст"
          />
          {title && (
            <SelectControl
              __next40pxDefaultSize
              __nextHasNoMarginBottom={true}
              label="Положение заголовка"
              value={positiontitle}
              options={[
                { label: 'Слева', value: '' },
                { label: 'По центру', value: 'justify-content-center' },
              ]}
              onChange={(value) => setAttributes({ positiontitle: value })}
            />
          )}
          <TextControl
            __next40pxDefaultSize
            __nextHasNoMarginBottom={true}
            label="Ссылка в блоке"
            value={url}
            onChange={(value) => setAttributes({ url: value })}
            type="url"
            placeholder="Введите url"
          />
          <SelectControl
            __next40pxDefaultSize
            __nextHasNoMarginBottom={true}
            label="Отступы блока"
            value={padding}
            options={[
              { label: 'Без отступа', value: '' },
              { label: 'Сверху', value: 'pt-5' },
              { label: 'Снизу', value: 'pb-5' },
              { label: 'Сверху и снизу', value: 'py-5' },
            ]}
            onChange={(value) => setAttributes({ padding: value })}
          />
          <ToggleControl
            __nextHasNoMarginBottom={true}
            label="Серый фон"
            checked={colorbg}
            onChange={(value) => setAttributes({ colorbg: value })}
          />
          <ToggleControl
            __nextHasNoMarginBottom={true}
            label="Отключить контейнер"
            help="Нужен для отключения лишних отступов"
            checked={container}
            onChange={(value) => setAttributes({ container: value })}
          />
        </PanelBody>
        <PanelBody title="Вопросы" initialOpen={true}>
          {pages?.map((page) => (
            <CheckboxControl
              label={page.title.rendered}
              checked={slides.includes(page.id)}
              onChange={(isChecked) =>
                handleChange('slides', page.id, isChecked)
              }
            />
          ))}
        </PanelBody>
      </InspectorControls>
      <div {...blockProps}>
        <div className="custom-slider__container">
          <div className="custom-slider__title">
            {title ? title : 'Часто задаваемые вопросы'}
          </div>
        </div>
      </div>
    </>
  );
}
